import Vaccinations from '../sections/vaccinations/vaccinations';

export default function VaccinationsPage() {
  return (
    <div className="section-page">
      <Vaccinations />
    </div>
  );
}
